import { render } from "./ParameterChart.vue?vue&type=template&id=dd510aee&scoped=true"
import script from "./ParameterChart.vue?vue&type=script&lang=js"
export * from "./ParameterChart.vue?vue&type=script&lang=js"

import "./ParameterChart.vue?vue&type=style&index=0&id=dd510aee&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd510aee"]])

export default __exports__